module.exports = __webpack_public_path__ + "img/card.561518ff.svg";